import {
  exportPcrReportReportsPcrExportGet,
  getPcrReportReportsPcrGet,
} from './api/sdk.gen';
import type {
  ExportPcrReportReportsPcrExportGetData,
  GetPcrReportReportsPcrGetData,
  PcrStatusFilter,
} from './api/types.gen';

export type {
  PcrReportResult,
  PcrReportRow,
  PcrSortBy,
  PcrStatusFilter,
} from './api/types.gen';
export type { SortOrder as SortDirection } from './api/types.gen';

export type PcrReportQuery = Omit<
  NonNullable<GetPcrReportReportsPcrGetData['query']>,
  'status'
> & {
  status: PcrStatusFilter;
};

export async function getPcrReport(query: PcrReportQuery) {
  return getPcrReportReportsPcrGet({
    query: { ...query },
    throwOnError: true,
  });
}

export async function exportPcrReport(
  query: Omit<PcrReportQuery, 'page' | 'page_size'>
) {
  const exportQuery: NonNullable<
    ExportPcrReportReportsPcrExportGetData['query']
  > = query;
  return exportPcrReportReportsPcrExportGet({
    query: exportQuery,
    responseType: 'blob',
    throwOnError: true,
  });
}
